export default {
  getUTCFullDate: (date = new Date()) => new Date(date).toUTCString().slice(0, -12),
  getUTCDay: (date = new Date()) => new Date(date).toUTCString().split(',')[0],
  getUTCDate: (date = new Date()) => new Date(date).toUTCString().split(' ')[1],
  getUTCMonth: (date = new Date()) => new Date(date).toUTCString().split(' ')[2],
  getUTCYear: (date = new Date()) => new Date(date).toUTCString().split(' ')[3],
  getUTCTime: (date = new Date()) => new Date(date).toUTCString().split(' ')[4],
  getUTCShortTime: (date = new Date()) => new Date(date).toUTCString().split(' ')[4].slice(0, 5),
  formatEventDateRange(startDate, endDate) {
      const startYear = this.getUTCYear(startDate);
      const endYear = this.getUTCYear(endDate);
      
      if (startYear === endYear) {
        // Same year: show format like "31 Jan - 03 Feb 2026"
        return `${this.getUTCDate(startDate)} ${this.getUTCMonth(startDate)} - ${this.getUTCDate(endDate)} ${this.getUTCMonth(endDate)} ${endYear}`;
      } else {
        // Different years: show full dates like "31 Dec 2025 - 2 Jan 2026"
        return `${this.getUTCDate(startDate)} ${this.getUTCMonth(startDate)} ${startYear} - ${this.getUTCDate(endDate)} ${this.getUTCMonth(endDate)} ${endYear}`;
      }
    }

};
